import { KAKI_MAKAN_LANDING_PAGE } from "@config/kakiMakan";
import { NDR_2025_PAGE } from "@config/ndr2025";
import { PRESIDENT_ADDRESS_PAGE } from "@config/presidentAddress";
import { ArticlePage } from "@pages/Article/Article.tsx";
import { AuthorPage } from "@pages/Author/AuthorPage";
import { FoodMapPage } from "@pages/FoodMap/FoodMapPage";
import { HomePage } from "@pages/Home/Home.tsx";
import { KakiMakanSectionPage } from "@pages/KakiMakan/KakiMakan";
import { KeywordPage } from "@pages/Keyword/Keyword";
import KuizPage from "@pages/Kuiz/Kuiz";
import { NewsletterPage } from "@pages/Newsletter/Newsletter";
import { NewsletterPreview } from "@pages/Newsletter/NewsletterPreview";
import { NewsletterUnsubscribePage } from "@pages/Newsletter/NewsletterUnsubscribe/NewsletterUnsubscribe";
import PodcastPage from "@pages/Podcast/Podcast";
import { PresidentAddress } from "@pages/PresidentAddress/PresidentAddress";
import { SearchResultPage } from "@pages/Search/SearchResult";
import { SeasonalTags } from "@pages/SeasonalTags/SeasonalTags";
import { SectionPage } from "@pages/Section/Section";
import BHServices from "@pages/StaticPages/BHServices";
import HubungiKami from "@pages/StaticPages/HubungiKami";
import KenaliKami from "@pages/StaticPages/KenaliKami";
import { UGCLandingPage } from "@pages/UGC/UGCLandingPage/UGCLandingPage";
import { UGCListingPage } from "@pages/UGC/UGCListingPage/UGCListingPage";
import VideoPage from "@pages/Video/Video";
import Webinar from "@pages/Webinar/Webinar";
import { fetchContext } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router";

import App from "./App";
import NotFound from "./pages/NotFound";

export const sectionPaths = [
  "/singapura/masyarakat",
  "/singapura/politik",
  "/singapura/perumahan",
  "/singapura/pendidikan",
  "/singapura/kesihatan",
  "/singapura/pengangkutan",
  "/singapura/jenayah-mahkamah",
  "/dunia/indonesia",
  "/dunia/timur-tengah",
  "/ekonomi-kerja/pekerjaan",
  "/ekonomi-kerja/aset",
  "/ekonomi-kerja/niaga",
  "/gaya-hidup/mahligai",
  "/gaya-hidup/wanita",
  "/gaya-hidup/hiburan",
  "/wacana/pandangan",
  "/wacana/hidayah",
];

export const reactRouterRoutes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <HomePage />,
        loader: fetchContext,
      },
      /**
       * Integration guide: https://sph.atlassian.net/wiki/x/V4GqY
       */
      {
        path: "/ringkasan-berita-harian",
        element: <NewsletterPage />,
        loader: fetchContext,
      },
      {
        path: "/bh_newsletter/unsubscribe",
        element: <NewsletterUnsubscribePage />,
        loader: fetchContext,
      },
      {
        path: "/newsletter/preview",
        element: <NewsletterPreview />,
        loader: fetchContext,
      },
      {
        path: "/mysph/login.php/",
        element: <></>,
        loader: fetchContext,
      },
      {
        path: "/foodmap",
        element: <FoodMapPage />,
        loader: fetchContext,
      },
      {
        path: "/kuiz-bh",
        element: <KuizPage />,
        loader: fetchContext,
      },
      {
        path: "/hubungi-kami",
        element: <HubungiKami />,
        loader: fetchContext,
      },
      {
        path: "/kenali-kami",
        element: <KenaliKami />,
        loader: fetchContext,
      },
      {
        path: "/bh-services",
        element: <BHServices />,
        loader: fetchContext,
      },
      {
        path: "/webinar",
        element: <Webinar />,
        loader: fetchContext,
      },
      {
        path: "/ge2025-pilihan-raya-umum",
        element: <></>,
        loader: fetchContext,
      },
      {
        path: `/${NDR_2025_PAGE}`,
        element: <SeasonalTags />,
        loader: fetchContext,
      },
      {
        path: `/${PRESIDENT_ADDRESS_PAGE}`,
        element: <PresidentAddress />,
        loader: fetchContext,
      },
      {
        path: `/${KAKI_MAKAN_LANDING_PAGE}`,
        element: <KakiMakanSectionPage />,
        loader: fetchContext,
      },
      {
        path: "/article/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/videos",
        element: <VideoPage />,
        loader: fetchContext,
      },
      {
        path: "/videos/:level1",
        element: <VideoPage />,
        loader: fetchContext,
      },
      {
        path: "/podcasts",
        element: <PodcastPage />,
        loader: fetchContext,
      },
      {
        path: "/podcasts/:level1",
        element: <PodcastPage />,
        loader: fetchContext,
      },
      {
        path: "/mata-mata",
        element: <UGCLandingPage />,
        loader: fetchContext,
      },
      {
        path: "/mata-mata/:level1",
        element: <UGCListingPage />,
        loader: fetchContext,
      },
      {
        path: "/mata-mata/:campaignId/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/tags/:level1",
        element: <KeywordPage />,
        loader: fetchContext,
      },
      {
        path: "/taxonomy/term/:id",
        element: <KeywordPage />,
        loader: fetchContext,
      },
      {
        path: "/author/:level1",
        element: <AuthorPage />,
        loader: fetchContext,
      },

      // Dynamically generated SectionPage routes
      ...sectionPaths.map((path) => ({
        path,
        element: <SectionPage />,
        loader: fetchContext,
      })),

      {
        path: "/search/site/:searchValue",
        element: <SearchResultPage />,
        loader: fetchContext,
      },
      {
        path: "/:section/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/:parent/:section/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/:level1",
        element: <SectionPage />,
        loader: fetchContext,
      },
      {
        path: "*",
        element: <NotFound />,
        loader: fetchContext,
      },
    ],
  },
];

export const routes = reactRouterRoutes.reduce(
  (_routes: string[], currentRoute: RouteObject) => {
    if (currentRoute.path) {
      _routes = [..._routes, currentRoute.path];
    }

    if (currentRoute.children) {
      for (const child of currentRoute.children) {
        if (child.path) {
          _routes = [..._routes, child.path];
        }
      }
    }

    return _routes;
  },
  [],
);
